<template>
    <div>

         <transition name="fade">

<div @click="removemodal" v-if="isShowModal" class="modal" v-bind:class="{ 'is-active': isShowModal }">



  <div class="modal-background"></div>

  <div class="modal-content">


<div class="container">
      <img  class="object-fit-cover" @click="removemodal" :src="imagesource"  alt="" >
</div>







  </div>
 <!-- <button @click="removemodal" class="modal-close is-large" aria-label="close"></button>-->

</div>

  </transition>

    </div>
</template>

<script>
    export default {

        data() {
            return {
                isShowModal: false,
                imagesource: '',
                ratio:'image is-2by3'	

            }
        },

        methods: {
                    Display(valueimage) {

                    this.imagesource = valueimage,
                    this.isShowModal = true;

                    },

                    removemodal() {

                    this.isShowModal = false;
                    
                    },
        },
        
    }
</script>

<style scoped>

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.object-fit-cover {
  width: 100%;
  height: 100%;
  object-fit: cover; /*magic*/
}

.container {

}

</style>